import api from "@/plugins/api";
import { logger } from "@/infrastructure/services/LoggerService";
import { mapResponseToProfile } from "../mappers/ProfileMapper";
/**
 * Profile Service Implementation
 * Handles API calls to the BFF for profile management
 */
export class ProfileService {
    async getProfile() {
        try {
            const response = await api.get("/user-profile/user", {
                unwrapEnvelope: true,
            });
            return mapResponseToProfile(response.data);
        }
        catch (error) {
            logger.debug("Failed to get profile:", error);
            throw error;
        }
    }
    async updateProfile(profile, avatarFile, removeAvatar) {
        try {
            const formData = new FormData();
            formData.append("first_name", profile.firstName);
            formData.append("last_name", profile.surname);
            formData.append("email", profile.email);
            formData.append("preferred_language", profile.displayLanguage || "en-GB");
            if (profile.phoneNationalNumber) {
                formData.append("phone_national_number", profile.phoneNationalNumber);
            }
            if (profile.phoneCountryCode) {
                formData.append("phone_country_code", profile.phoneCountryCode);
            }
            if (profile.department) {
                formData.append("department", profile.department);
            }
            if (profile.jobTitle) {
                formData.append("job_title", profile.jobTitle);
            }
            if (profile.timeZone) {
                formData.append("time_zone_id", profile.timeZone);
            }
            if (profile.timeFormat) {
                formData.append("time_format", profile.timeFormat);
            }
            if (profile.dateFormat) {
                formData.append("date_format", profile.dateFormat);
            }
            if (avatarFile) {
                formData.append("avatar_file", avatarFile);
            }
            if (removeAvatar) {
                formData.append("remove_avatar", "true");
            }
            await api.put("/user-profile/user", formData, {
                unwrapEnvelope: true,
                headers: { "Content-Type": "multipart/form-data" },
            });
        }
        catch (error) {
            logger.debug("Failed to update profile:", error);
            throw error;
        }
    }
    async getFieldConfiguration() {
        try {
            const response = await api.get("/schema/user-profile/field-config", {
                unwrapEnvelope: true,
            });
            return response.data;
        }
        catch (error) {
            logger.debug("Failed to get field configuration:", error);
            throw error;
        }
    }
    async getAvailableTimeZones() {
        try {
            const response = await api.get("/available-time-zones", {
                unwrapEnvelope: true,
            });
            return response.data.map((tz) => ({ value: tz.id, label: tz.label }));
        }
        catch (error) {
            logger.debug("Failed to get available time zones:", error);
            throw error;
        }
    }
}
